/**
 * PHP 代码生成器
 * 生成使用 cURL 扩展的 PHP HTTP 请求代码
 */

import { BaseCodeGenerator } from './base.js';

export class PhpGenerator extends BaseCodeGenerator {
  constructor() {
    super({
      language: 'php',
      library: 'curl',
      indent: '    ',
      maxLineLength: 80
    });
  }

  generate(parsedCurl) {
    this.validateParsedCurl(parsedCurl);

    const lines = [];
    lines.push('<?php');
    lines.push('');
    lines.push(this.generateComment(`发送 ${parsedCurl.method} 请求到 ${parsedCurl.url}`));
    lines.push('$ch = curl_init();');
    lines.push('');
    lines.push(`curl_setopt($ch, CURLOPT_URL, "${this.escapeString(parsedCurl.url)}");`);
    lines.push('curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);');
    
    if (parsedCurl.method !== 'GET') {
      lines.push(`curl_setopt($ch, CURLOPT_CUSTOMREQUEST, "${parsedCurl.method}");`);
    }

    if (Object.keys(parsedCurl.headers).length > 0) {
      lines.push('');
      lines.push('$headers = [');
      Object.entries(parsedCurl.headers).forEach(([key, value]) => {
        lines.push(`    "${this.escapeString(key)}: ${this.escapeString(value)}",`);
      });
      lines.push('];');
      lines.push('curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);');
    }

    if (parsedCurl.data.type !== 'none') {
      lines.push('');
      lines.push(`$data = "${this.escapeString(parsedCurl.data.content)}";`);
      lines.push('curl_setopt($ch, CURLOPT_POSTFIELDS, $data);');
    }

    if (parsedCurl.insecure) {
      lines.push('');
      lines.push('curl_setopt($ch, CURLOPT_SSL_VERIFYPEER, false);');
    }

    if (parsedCurl.followRedirects) {
      lines.push('curl_setopt($ch, CURLOPT_FOLLOWLOCATION, true);');
    }

    lines.push('');
    lines.push('$response = curl_exec($ch);');
    lines.push('');
    lines.push('if (curl_errno($ch)) {');
    lines.push('    echo "Error: " . curl_error($ch);');
    lines.push('} else {');
    lines.push('    echo $response;');
    lines.push('}');
    lines.push('');
    lines.push('curl_close($ch);');
    lines.push('?>');

    return lines.join('\n');
  }

  generateComment(text) {
    return `// ${text}`;
  }

  escapeString(str) {
    return str
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/\t/g, '\\t');
  }
}